export default function footerScripts(localStorageService, siteImproveLoader) {
    return {
        restrict: "E",
        scope: {},
        replace: true,
        // template: require("./template.html"),

        controller: function ($scope, $rootScope) {
            var scriptHandler_statistics = function (allowedCookies) {
                if (allowedCookieCats) {
                    if (allowedCookies.indexOf("statistics") !== -1) {
                        // ADD SITEIMPROVE SCRIPT
                        siteImproveLoader.injectScript();
                    }

                    if (allowedCookies.indexOf("statistics") == -1) {
                        // REMOVE SITEIMPROVE SCRIPT
                        siteImproveLoader.destroyScript();
                    }
                }
            };

            var allowedCookieCats =
                localStorageService.cookie.get("cookieCompliance");

            scriptHandler_statistics(allowedCookieCats);

            // CHECK CATEGORIES ON UPDATE
            var cookieUpdatedEventListener = $rootScope.$on(
                "cookie-compliance-updated",
                function () {
                    //** Could have updated */
                    allowedCookieCats =
                        localStorageService.cookie.get("cookieCompliance");
                    allowedCookieCats;
                    scriptHandler_statistics(allowedCookieCats);
                }
            );

            $scope.$on("$destroy", cookieUpdatedEventListener);
        },
    };
}
